module.exports = __webpack_public_path__ + "img/pay-welfare-bg.a9bd6f2f.png";